const CHATS_SIDEBAR_REFRESH_EVENT = 'chats-sidebar-refresh'
const CHATS_SIDEBAR_TOUCH_EVENT = 'chats-sidebar-touch'

/**
 * Existing hosted thread: bump that row locally.
 * New, unbound, or moved thread: reload the list so the row appears.
 */
export function sidebarUpdateForAgentChatThread(args: {
  fromThreadId?: string | null
  toThreadId: string
}): 'refresh' | 'touch' {
  const from = args.fromThreadId ? String(args.fromThreadId) : ''
  const to = String(args.toThreadId || '')
  if (!to || !from || from.startsWith('new-') || from !== to) return 'refresh'
  return 'touch'
}

/** Ask ChatsSidebarPanel to reload threads from the API. */
export function refreshChatsSidebar(manual = false): void {
  window.dispatchEvent(
    new CustomEvent(CHATS_SIDEBAR_REFRESH_EVENT, { detail: { manual } }),
  )
}

/** Move one already-listed thread to "now" without refetching the sidebar. */
export function touchChatSidebarThread(threadId: string): void {
  const id = String(threadId || '').trim()
  if (!id) return
  window.dispatchEvent(
    new CustomEvent(CHATS_SIDEBAR_TOUCH_EVENT, { detail: { threadId: id } }),
  )
}

export function chatsSidebarTouchEventName(): string {
  return CHATS_SIDEBAR_TOUCH_EVENT
}

export function chatsSidebarRefreshEventName(): string {
  return CHATS_SIDEBAR_REFRESH_EVENT
}

const CLOSE_CHAT_CONVERSATION_TAB_EVENT = 'close-chat-conversation-tab'
const FOCUS_CHAT_COMPOSER_EVENT = 'focus-chat-composer'

/** Focus the chat composer for a hosted thread (editor tab or agent panel). */
export function focusChatComposer(threadId?: string): void {
  window.dispatchEvent(
    new CustomEvent(FOCUS_CHAT_COMPOSER_EVENT, { detail: { threadId } }),
  )
}

export function focusChatComposerEventName(): string {
  return FOCUS_CHAT_COMPOSER_EVENT
}

/** Close editor tab and agent-panel host for a thread after archive/delete. */
export function dismissChatThreadSurfaces(threadId: string): void {
  window.dispatchEvent(
    new CustomEvent(CLOSE_CHAT_CONVERSATION_TAB_EVENT, { detail: { threadId } }),
  )
}

const CHAT_AGENT_PANEL_COLLAPSE_EVENT = 'chat-agent-panel-collapse'

/** Collapse the right agent panel (e.g. after moving chat to an editor tab). */
export function collapseChatAgentPanel(): void {
  window.dispatchEvent(new CustomEvent(CHAT_AGENT_PANEL_COLLAPSE_EVENT))
}

export function chatAgentPanelCollapseEventName(): string {
  return CHAT_AGENT_PANEL_COLLAPSE_EVENT
}
